// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* V2 전용 전산프로그램 스타일 */

/* 1920x920 화면 기준 레이아웃 */
.v2-layout {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
}

#v2-contents {
  height: calc(100vh - 60px);
  max-height: 920px;
  overflow: hidden;
}

/* 기본 컨테이너 */
.v2-container {
  background: #f9fafb;
  border: 1px solid #d1d5db;
  padding: 16px;
}

/* 입력 필드 */
.v2-input {
  background: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 0;
  padding: 8px 12px;
  font-size: 14px;
}

.v2-input:focus {
  background: white;
  border-color: #999;
  outline: none;
}

/* 테이블 헤더 */
.v2-table-header {
  background: #f5f5f5;
  border-bottom: 1px solid #d1d5db;
  font-weight: 500;
}

/* 테이블 행 호버 */
.v2-table-row:hover {
  background: #f3f4f6;
}

/* 버튼 스타일 */
.v2-button {
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 0;
  padding: 8px 16px;
  cursor: pointer;
}

.v2-button:hover {
  background: #f5f5f5;
}

.v2-button.active {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/v2/styles/v2.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB,wBAAwB;AACxB;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB","sourcesContent":["/* V2 전용 전산프로그램 스타일 */\n\n/* 1920x920 화면 기준 레이아웃 */\n.v2-layout {\n  width: 100%;\n  max-width: 1920px;\n  margin: 0 auto;\n}\n\n#v2-contents {\n  height: calc(100vh - 60px);\n  max-height: 920px;\n  overflow: hidden;\n}\n\n/* 기본 컨테이너 */\n.v2-container {\n  background: #f9fafb;\n  border: 1px solid #d1d5db;\n  padding: 16px;\n}\n\n/* 입력 필드 */\n.v2-input {\n  background: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 0;\n  padding: 8px 12px;\n  font-size: 14px;\n}\n\n.v2-input:focus {\n  background: white;\n  border-color: #999;\n  outline: none;\n}\n\n/* 테이블 헤더 */\n.v2-table-header {\n  background: #f5f5f5;\n  border-bottom: 1px solid #d1d5db;\n  font-weight: 500;\n}\n\n/* 테이블 행 호버 */\n.v2-table-row:hover {\n  background: #f3f4f6;\n}\n\n/* 버튼 스타일 */\n.v2-button {\n  background: white;\n  border: 1px solid #d1d5db;\n  border-radius: 0;\n  padding: 8px 16px;\n  cursor: pointer;\n}\n\n.v2-button:hover {\n  background: #f5f5f5;\n}\n\n.v2-button.active {\n  background: #3b82f6;\n  color: white;\n  border-color: #3b82f6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
